module.exports = __webpack_public_path__ + "static/media/rivyo-product-review.51bc4be5.png";